import { useState } from 'react';

const useSessionStorage = <T>(key: string, initialValue: T | null): [T | null, (value: T | null) => void] => {
  const [storedValue, setStoredValue] = useState<T | null>(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error('Error loading from sessionStorage:', error);
      return initialValue;
    }
  });

  const setValue = (value: T | null) => {
    try {
      if (value === null) {
        window.sessionStorage.removeItem(key);
      } else {
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.error('Error saving to sessionStorage:', error);
    }
  };

  return [storedValue, setValue];
}

export default useSessionStorage;